import React from "react";
import { useTranslation } from "react-i18next";
import { Card, Input, Typography, Alert } from "antd";
import { imagenDeRespaldo } from "../../imagenDeRespaldo";

const { Paragraph, Text } = Typography;

export function Step2SceneDescription({ scene, description, onChange }) {
  const { t } = useTranslation("rooms");
  const FALLBACK_IMG = imagenDeRespaldo(t("detalleSala.sinImagen"), {
    ancho: 640,
    alto: 320,
  });

  const title =
    scene?.module_01?.ModOneTitle || t("asistenteEscena.paso2.escenaSinTitulo");
  const img = scene?.module_01?.bannertop?.url || FALLBACK_IMG;

  return (
    <div className="wizard-step">
      <Card
        variant="borderless" // ✅ en vez de bordered={false}
        className="revi-scene-preview-card"
        cover={
          <img
            src={img}
            alt={title}
            style={{ width: "100%" }}
            onError={(e) => {
              e.currentTarget.src = FALLBACK_IMG;
            }}
          />
        }
      >
        <Text strong>{title}</Text>
      </Card>

      <div className="form-section">
        <Alert
          type="info"
          showIcon
          title={t("asistenteEscena.paso2.avisoTitulo")} // ✅ en vez de message
          description={t("asistenteEscena.paso2.avisoDescripcion")}
          style={{ marginBottom: 12 }}
        />

        <Paragraph type="secondary" style={{ marginBottom: 8 }}>
          {t("asistenteEscena.paso2.etiquetaDescripcion")}
        </Paragraph>

        <Input.TextArea
          value={description}
          onChange={(e) => onChange(e.target.value)}
          placeholder={t("asistenteEscena.paso2.descripcionPlaceholder")}
          autoSize={{ minRows: 4, maxRows: 8 }}
        />
      </div>
    </div>
  );
}
